import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Link,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useOrganization } from "src/hooks/useOrganization";
import * as Url from "src/services/url";

export function PaymentNotConfigured() {
  const organization = useOrganization();
  return (
    <Alert status="error">
      <AlertIcon />
      <AlertTitle>Payment setup incomplete.</AlertTitle>
      <AlertDescription>
        Finish configuring payments in{" "}
        <Link
          textDecoration="underline"
          as={RouterLink}
          to={organization
            .map((org) => Url.OrgAdmin.Org.settings(org, "tools"))
            .withDefault("#")}
        >
          payment settings
        </Link>{" "}
        to start accepting payments.
      </AlertDescription>
    </Alert>
  );
}
